import React, { useEffect } from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import { Box, Typography } from "@mui/material";
import { Congiguration } from "../../Constants/AppConstants";
import { useSelector, useDispatch } from "react-redux";
import { getServiceDistribution, } from "../../Actions/QuoteAction";
import { useNavigate } from "react-router-dom";
import { ServiceDistributionSection, PaginationBox } from './ServiceDistributionTabStyled'
import ServiceDistributionEdit from "./ServiceDistributionEdit";
import GlobalServiceDistribution from './GlobalServiceDistribution'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from "@mui/material/styles";
import { Constant } from './Constant';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { read, utils, writeFileXLSX } from "xlsx";
import { saveUpdateServiceDistribution } from "../../Actions/ServiceDistributionAction";
import ValidationAccordionComp from './ValidationAccordian'
import Pagination from '@mui/material/Pagination';
import checkIcon from '../../images/checkIcon.svg'
import closeIcon from '../../images/closeIcon.svg'
import ConfirmBox from './ConfirmBox';
import Notification from "../utilities/Notification/Notification";
import { Severity } from "../utilities/Notification/NotificationContent";
import Loader from "../utilities/Loader/Loader";

const normalizeColumnName = (columnName) =>
    String(columnName ?? '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');

const componentColumnAliases = {
    inmyhandscbt: [
        'In My Hands (cCBT)',
        'Computerized CBT (English only)',
        'Computerzied CBT)English only)',
    ],
};

const getComponentColumnAliases = (componentName) => {
    const normalizedName = normalizeColumnName(componentName);
    const aliasEntry = Object.values(componentColumnAliases)
        .find((aliases) => aliases.some((alias) =>
            normalizeColumnName(alias) === normalizedName));

    return aliasEntry || [componentName];
};



const ServiceDistributionTab = ({ quoteDetails, pricing,handleFunction }) => {
    const [componentList, setComponentList] = useState([]);
    const [utilizationDistributionRows, setUtilizationDistributionRows] = useState([]);
    const [utilizationDistributionComponents, setUtilizationDistributionComponents] = useState([]);
    const [utilizationDistributionCountries, setUtilizationDistributionByCountries] = useState([]);
    const [isDistributionEditable, setIsDistributionEditable] = useState(false);
    const [serviceDistributionUploadFileName, setServiceDistributionUploadFileName] = useState('');
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isValidUpload, setisValidUpload] = useState(false);
    const [showConfirm, setshowConfirm] = useState(false);
    const [showMessage, setshowMessage] = useState('');
    const [inValiddistribution, setinValiddistribution] = useState(false);
    const [validDistribution, setValidDistribution] = useState(false);
    const [validationMessages,setValidationMessages]=useState([]);
    const [dialogeType, setdialogeType] = useState(true);
    const [activeUpload, setactiveUpload] = useState(false);
    const [notificationMsg, setNotificationMsg] = useState('');
    const [showNotification, setShowNotification] = useState(false);
    const [notificationSeverity, setNotificationSeverity] = useState('');
    const [loadingState, setLoadingState] = useState(false);
    const loggedUser = useSelector((state) => state.UserReducer.loggedUser);
    const dispatch = useDispatch();
    const VisuallyHiddenInput = styled("input")({
        clip: "rect(0 0 0 0)",
        clipPath: "inset(50%)",
        height: 1,
        overflow: "hidden",
        position: "absolute",
        bottom: 0,
        left: 0,
        whiteSpace: "nowrap",
        width: 1,
    });
    useEffect(() => {
        GetServiceDistribution();
    }, []);

    const GetServiceDistribution = () => {
        dispatch(getServiceDistribution(Congiguration.CompanyId, quoteDetails.productId, quoteDetails.productVariationId, quoteDetails.quoteId)
        )
            .then((data) => {
                bindServiceDistribution(data);
                setLoadingState(false);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    function bindServiceDistribution(utilizationDistributionData) {
        const utilizationDistributionSet = new Set();
        const uniqueUtilizationDistributionKeys =
            utilizationDistributionData.utilizationDistributions?.filter((item) => {
                const duplicate = utilizationDistributionSet.has(item.countryId);
                utilizationDistributionSet.add(item.countryId);
                return !duplicate;
            });
       
        setUtilizationDistributionByCountries(uniqueUtilizationDistributionKeys);
        setUtilizationDistributionComponents(
            utilizationDistributionData.components
        );
        setUtilizationDistributionRows([
            ...utilizationDistributionData.utilizationDistributions,
        ]);
        console.log('uniqueUtilizationDistributionKeys', uniqueUtilizationDistributionKeys);
        console.log('components', utilizationDistributionData.components);
        console.log('utilizationDistributions', utilizationDistributionData.utilizationDistributions);
    }
    const downloadExcel = () => {
        setactiveUpload(true);
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        // Build the sheet from the raw distribution data with full precision. The UI table
        // values are rounded to 2 decimals for display, which can make a country's
        // utilization sum differ from 100% and fail validation when re-uploaded.
        const exportRows = [...utilizationDistributionCountries]
            .sort((a, b) => a.countryName.localeCompare(b.countryName))
            .map((country) => {
                const row = {
                    'Country': country.countryName,
                    'Head Count': country.headcount,
                    'Product': country.productName,
                    'Product Variation': country.productVariationName,
                };
                utilizationDistributionComponents.forEach((component) => {
                    const distribution = utilizationDistributionRows.find((x) =>
                        x.countryId === country.countryId &&
                        x.productId === country.productId &&
                        x.productVariationId === country.productVariationId &&
                        x.componentId === component.componentId);
                    row[component.componentName] = distribution ? distribution.utilizationPercent : 0;
                });
                return row;
            });
        const ws = XLSX.utils.json_to_sheet(exportRows);
        // Create a new workbook and add the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        // Create a blob from the workbook
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        // const quoteIdFileName = quoteId['quoteId'];
        saveAs.saveAs(data, quoteDetails.quoteName + fileExtension);

    };
    function setValidationMsg(msg) {

        //return utilizationDistributionComponents.find(x => x.componentName === componentName).componentId;

    }

    const handleFile = async (e) => {
               setValidDistribution([]);
               setValidationMessages([]);
               setshowConfirm(false);
               setisValidUpload(false);
               setLoadingState(true);
        let isNegative = false;
        let isMoreThanlimit = false;
        const file = e.target.files[0];
        
        if(file)
        {
            
            if(file.name.endsWith('.xlsx'))
            {
                try
                {const data = await file.arrayBuffer();
                setServiceDistributionUploadFileName(file.name);
                /* parse */
                
                const wb = read(data);
                
                const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
                //const newArray = originalArray.map(({ id, name }) => ({ id, name }));
                const filedata = utils.sheet_to_json(ws);
                e.target.file = null;
                if(filedata.length === 0)
                {
                    setNotificationMsg(Constant.EMPTYFILEERROR);
                    setNotificationSeverity(Severity.ERROR);
                    setShowNotification(true);
                    setLoadingState(false);
                }
                else
                {
                    
                    const metadataColumnNames = [
                        'Country',
                        'Head Count',
                        'Product',
                        'Product Variation',
                    ];
                    const fileColumnNames = Object.keys(filedata[0]);
                    const getComponentForColumn = (columnName) =>
                        utilizationDistributionComponents.find((component) =>
                            getComponentColumnAliases(component?.componentName)
                                .some((alias) =>
                                    normalizeColumnName(alias) === normalizeColumnName(columnName)));
                    const missingColumnNames = [
                        ...metadataColumnNames.filter((columnName) =>
                            !fileColumnNames.some((fileColumnName) =>
                                normalizeColumnName(fileColumnName) === normalizeColumnName(columnName))),
                        ...utilizationDistributionComponents
                            .filter((component) =>
                                !fileColumnNames.some((fileColumnName) =>
                                    getComponentForColumn(fileColumnName) === component))
                            .map((component) => component.componentName),
                    ];
                    console.log(utilizationDistributionCountries,"utilizationDistributionCountries");
                    // let output = [{ Email: 'haha@yopmail.com', KolomB: 'Haha', KolomC: 6, ' Kolom D ': '3.000.000', KolomE: '2022-01-01T16:59:48.000Z' }, { Email: 'blabla@gmail.com', KolomB: 'blabla', KolomC: 6, ' Kolom D ': '3.000.000', KolomE: '2022-01-01T16:59:48.000Z' }];
                    let invalid = missingColumnNames.length > 0;
                    filedata?.forEach((obj) => {
                        const rowHasAllColumns = metadataColumnNames.every((columnName) =>
                            Object.keys(obj).some((fileColumnName) =>
                                normalizeColumnName(fileColumnName) === normalizeColumnName(columnName))) &&
                            utilizationDistributionComponents.every((component) =>
                                Object.keys(obj).some((fileColumnName) =>
                                    getComponentForColumn(fileColumnName) === component));
                        if (!rowHasAllColumns) {
                            invalid=true;
                            setNotificationMsg(Constant.INVALIDHEADERERROR);
                            setNotificationSeverity(Severity.ERROR);
                            setShowNotification(true);
                            setLoadingState(false);
                            return false;
                        }
                    });
                    if(!invalid)
                    {
                        let objArr = [];
                        filedata?.forEach((obj) => {
                            const objCountry = utilizationDistributionCountries?.find(x => x.countryName === obj.Country);
                            if(objCountry)
                            {
                                let countryId = objCountry.countryId;
                                let productId = objCountry.productId;
                                let productVariationId = objCountry.productVariationId;
                                let checkSum = 0.00;
                            
                                Object.keys(obj).forEach((key) => {

                                    let objServiceDistribution = {};
                                    const component = getComponentForColumn(key);
                                    if (component) {
                                        checkSum += parseFloat(obj[key]);
                                        if (parseFloat(obj[key]) < 0) {
                                            isNegative = true;
                                            objServiceDistribution.isNegative = true;
                                            setValidationMessages(prevArray => [...prevArray, `Value can't be Negative for ${key} for Country ${obj.Country}`])
                                            setNotificationMsg();
                                            setNotificationSeverity(Severity.ERROR);
                                            setShowNotification(true);
                                        }
                                        
                                        objServiceDistribution.countryId = countryId;
                                        objServiceDistribution.productId = productId;
                                        objServiceDistribution.productVariationId = productVariationId;
                                        objServiceDistribution.isNegative = false;
                                        objServiceDistribution.componentId = component.componentId;
                                        objServiceDistribution.utilizationPercent = parseFloat(obj[key]);
                                        objArr.push(objServiceDistribution);
                                    }
                                });
                                if ((parseFloat(checkSum.toFixed(10)) !== 100.00)) {
                                    isMoreThanlimit = true;
                                    setValidationMessages(prevArray => [...prevArray, `Total utilization percent for Country ${obj.Country} is not 100%`])
                                    //setNotificationMsg(`Total utilization percent for Country ${obj.Country} is not 100%`);
                                    setNotificationSeverity(Severity.ERROR);
                                    setShowNotification(true);
                                }
                            }
                            });
                            if(objArr.length===0)
                            {
                                setisValidUpload(false);
                                setNotificationMsg(`No data found`);
                                setNotificationSeverity(Severity.INFO);
                                setShowNotification(true);
                                setLoadingState(false);
                            }
                            else
                            {
                                if (!isNegative && !isMoreThanlimit) {
                                setshowConfirm(true);
                                setValidDistribution(objArr);
                                setisValidUpload(false);
                                setLoadingState(false);
                                setshowMessage(Constant.CONFIRMBOXTEXT);
                                }
                                else{ 
                                        setinValiddistribution(objArr);
                                        setisValidUpload(true);
                                        setNotificationMsg(`Uploaded Data is not Valid`);
                                        setNotificationSeverity(Severity.ERROR);
                                        setShowNotification(true);
                                        setLoadingState(false);
                                    }
                            }
                    }
                }
            }
                catch(error)
                {
                    console.log(error,"erorrrrrr");
                    setNotificationMsg("File Upload Failed. Please use another file.");
                    setNotificationSeverity(Severity.ERROR);
                    setShowNotification(true); 
                    setLoadingState(false);
                }
            }
            else{
                setNotificationMsg(Constant.WRONGFILETYPE);
                setNotificationSeverity(Severity.ERROR);
                setShowNotification(true);
                setLoadingState(false);  
            }
           
        }
        e.target.value=null;
        
    };
    const handleConfirm = () => {
        setshowConfirm(false);
            const serviceDistributionObj = {
                serviceDistributionVariations: validDistribution,
                quoteId: quoteDetails.quoteId,
                companyId: Congiguration.CompanyId,
                userId: loggedUser?.user.id
            }
            setLoadingState(true);
            dispatch(saveUpdateServiceDistribution(serviceDistributionObj))
            .then(data => {
                if (data === 1) {
                    handleFunction(quoteDetails.quoteId);
                    GetServiceDistribution();
                    setNotificationMsg(`Data updated successfully`);
                    setNotificationSeverity(Severity.SUCCESS);
                    setShowNotification(true);
                    setLoadingState(false)
                }
                else
                {
                    handleFunction(quoteDetails.quoteId);
                    GetServiceDistribution();
                    setNotificationMsg(Constant.FAILEDERROR);
                    setNotificationSeverity(Severity.ERROR);
                    setShowNotification(true);
                    setLoadingState(false)
                }
            })
            .catch(e => {
                console.log(e);
                setLoadingState(false)
            });
            
        };



    const CheckTotalPercentage = function (values) {
        let checkSum = 0.00;
        for (let i = 3; i < values.length; i++) {
            const value = (values[i] !== '') ? parseFloat(values[i]) : 0.00;
            checkSum += parseFloat(value);
        }

         ;
        console.log(checkSum);
        if (isNaN(checkSum)) {
            setshowConfirm(true);
            setdialogeType(false);
            setshowMessage(Constant.INPUTERROR1);
            return true;
        } else if (!(parseFloat(checkSum.toFixed(10)) === 100.00)) {
            setshowConfirm(true);
            setdialogeType(false);
            setshowMessage(Constant.INPUTERROR2);
            return true;
        }
        return false;
    };
    const SaveUodateServiceDistribution = function (finalArray) {

        var finalOutputArray = finalArray.map(({ Country, Product, ProductVariation: ProductVariation, AggregateReportingofHAresults: Aggregate_Reporting_of_HA_results, AwareMindfulnessProgram: Aware, ComputerizedCBTEnglishonly: Computerized_CBT, CounselingMatchToInsurance: Counseling_Match_To_Insurance, EnhancedFinancialServices: Enhanced_Financial_Services, EnhancedLegalServices: Enhanced_Legal_Services, GeneralAssistanceClinical: General_Assistance_Clinical, GeneralAssistanceWorkLife: General_Assistance_WorkLife, LifeCoaching: Life_Coaching, LiveWellWellnessPlatform: Live_Well_Wellness_Platform, ManagerAssist: Manager_Assist, OutreachCalls: Outreach_Calls, ParticipantWebsite: Participant_Website, Scheduledinpersonsessions: Scheduled_inperson_sessions, Scheduledphonesessions: Scheduled_phone_sessions, Scheduledvideosessions: Scheduled_video_sessions, SingleSessionTherapy: Single_Session_Therapy, WellnessCoachingStandard: Wellness_Coaching_Standard, WorkLifeCore: WorkLife_Core, WorkLifeLegalFinancial: WorkLife_LegalFinancial }) => ({ Country, Product, ProductVariation, Aggregate_Reporting_of_HA_results, Aware, Computerized_CBT, Counseling_Match_To_Insurance, Enhanced_Financial_Services, Enhanced_Legal_Services, General_Assistance_Clinical, General_Assistance_WorkLife, Life_Coaching, Live_Well_Wellness_Platform, Manager_Assist, Outreach_Calls, Participant_Website, Scheduled_inperson_sessions, Scheduled_phone_sessions, Scheduled_video_sessions, Single_Session_Therapy, Wellness_Coaching_Standard, WorkLife_Core, WorkLife_LegalFinancial }));
        const obj = {
            updateServiceDistributiomVariationTypes: finalOutputArray,
            quoteId: quoteDetails.quoteId,//"c525aef1-d944-41a0-9a5a-093057504df7",
            userId: loggedUser?.user.id
        }
        console.log(obj);

        dispatch(saveUpdateServiceDistribution(obj))
            .then(data => {
                if (data === 1) {

                    GetServiceDistribution();

                }
                console.log('save srv dist', data);
            })
            .catch(e => {

                console.log(e);
            });
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    function closeConfirm() {
        setshowConfirm(false);
    }
    const closeNotificationPopup = () => {
        setShowNotification(false);
    }
    return (
        <ServiceDistributionSection>
            <Box className="boxWrapper">
                <div className="boxHeading">
                    <Typography variant="h6">{Constant.HEADING}</Typography>
                    <Box className="requestformLeft">
                        <div className="heading">{Constant.HEADINGTEXT}</div>
                        <Button component="label" className={activeUpload ? "active" : "disbaled"} variant="contained" size="medium" startIcon={<CloudUploadIcon />}  >
                            {Constant.UPLOAD}
                            <VisuallyHiddenInput
                                type="file"
                                onChange={(e) => handleFile(e)}
                            />
                        </Button>
                        <Button component="label" className="uploadedFileName" variant="contained" size="medium" startIcon={<FileDownloadOutlinedIcon />} onClick={downloadExcel}>
                            {Constant.DOWNLOAD}
                        </Button>
                    </Box>
                </div>
                {isValidUpload &&
                    <ValidationAccordionComp
                        headers={utilizationDistributionComponents}
                        rows={inValiddistribution}
                        countries={utilizationDistributionCountries}
                        messages={validationMessages}
                    />
                }
                <div className="distribution">
                    <GlobalServiceDistribution
                        headers={utilizationDistributionComponents}
                        rows={pricing?.blendedComponentPercentUtilizations}
                        countries={utilizationDistributionCountries}
                    />
                </div>
                <div className="distribution">
                    <ServiceDistributionEdit
                        headers={utilizationDistributionComponents}
                        rows={utilizationDistributionRows}
                        countries={utilizationDistributionCountries.sort((a, b) => a.countryName.localeCompare(b.countryName))}
                        componentList={componentList}
                        isEditable={isDistributionEditable}
                        rowCount={rowsPerPage}
                        currentPage={page}
                    />
                    <PaginationBox>
                        <Typography variant='h6'>{utilizationDistributionCountries.length}<span>Total Results</span></Typography>
                        <Pagination
                            count={Math.ceil(utilizationDistributionCountries.length / rowsPerPage)}
                            page={page}
                            onChange={handleChangePage}
                        />
                    </PaginationBox>
                </div>
            </Box>
            {showConfirm &&
                <ConfirmBox
                    show={showConfirm}
                    title={dialogeType ? Constant.CONFIRM : ''}
                    imgsrc={dialogeType ? checkIcon : closeIcon}
                    heading={showMessage}
                    handleClose={closeConfirm}
                    handleConfirm={handleConfirm}
                    message={showMessage}
                />
            }
            {showNotification && (
                <Notification
                    open={showNotification}
                    onClose={closeNotificationPopup}
                    message={notificationMsg}
                    severity={notificationSeverity}
                />
            )}
             {loadingState && <Loader open={loadingState}/>}
        </ServiceDistributionSection>

    );
};
export default ServiceDistributionTab;
